export function stringifyWithoutNull(obj: any): string {
  return JSON.stringify(obj, (key, value) =>
    value === null ? undefined : value
  );
}
